const GOOGLE_IDENTITY_SCRIPT_ID = 'google-identity-services';
const GOOGLE_IDENTITY_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

let googleIdentityServicesPromise;

export const loadGoogleIdentityServices = () => {
  if (window.google?.accounts?.id) {
    return Promise.resolve(window.google.accounts.id);
  }

  if (googleIdentityServicesPromise) {
    return googleIdentityServicesPromise;
  }

  googleIdentityServicesPromise = new Promise((resolve, reject) => {
    const resolveGoogleIdentityServices = () => {
      if (window.google?.accounts?.id) {
        resolve(window.google.accounts.id);
      } else {
        googleIdentityServicesPromise = undefined;
        reject(new Error('Google Identity Services failed to initialize'));
      }
    };

    const rejectGoogleIdentityServices = () => {
      googleIdentityServicesPromise = undefined;
      reject(new Error('Google Identity Services failed to load'));
    };

    const existingScript = document.getElementById(GOOGLE_IDENTITY_SCRIPT_ID);

    if (existingScript) {
      existingScript.addEventListener('load', resolveGoogleIdentityServices, {
        once: true,
      });
      existingScript.addEventListener('error', rejectGoogleIdentityServices, {
        once: true,
      });
      return;
    }

    const script = document.createElement('script');
    script.id = GOOGLE_IDENTITY_SCRIPT_ID;
    script.src = GOOGLE_IDENTITY_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = resolveGoogleIdentityServices;
    script.onerror = rejectGoogleIdentityServices;
    document.head.appendChild(script);
  });

  return googleIdentityServicesPromise;
};
